var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.878 33.579"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7309"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3499",
    d: "M31.574 33.579H5.303a5.3 5.3 0 0 1-4.6-7.924L13.839 2.668a5.3 5.3 0 0 1 9.2 0l13.135 22.989a5.295 5.295 0 0 1-4.6 7.922Z",
    fill: "#ffb600"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7329"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7313"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7312"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7311"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7310"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3500",
    d: "M18.439 17.009a1.287 1.287 0 0 1 1.286 1.282v6.432a1.286 1.286 0 0 1-2.573 0v-6.432a1.287 1.287 0 0 1 1.287-1.282Z",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7314"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Shape 3077"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3501",
    d: "M18.439 11.002a1.718 1.718 0 0 1 1.715 1.715 1.713 1.713 0 0 1-1.713 1.715 1.715 1.715 0 1 1 0-3.43Z",
    fill: "#fff"
  }))))));
};
export default SvgWarning;